import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCurrencyRupees: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconCurrencyRupees"><Path d="M20 4.5H16.5C17.046 5.22681 17.4375 6.07631 17.625 7H20V9.5H17.625C17.0459 12.3528 14.5237 14.5 11.5 14.5H8.75781L16.9961 20.4717L15.5283 22.4961L4 14.1377V12H11.5C13.1326 12 14.5202 10.9563 15.0352 9.5H4V7H15.0352C14.5202 5.54375 13.1326 4.5 11.5 4.5H4V2H20V4.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCurrencyRupees;
